import React, {useContext, useState} from 'react';
import styles from './TeleOpSelection.module.css';
import robotArmSvg from '../../static_files/robot-arm-selection.svg'
import reservedBanner from '../../static_files/robot-arm-selection-reserved-banner.png';
import navRightArrow from '../../static_files/navRightArrow.svg'

import {SwapMainAppContext} from "../../context/SwapMainAppContext";
import {Link, useNavigate} from "react-router-dom";

const ROBOT_RENDER_DATA = [
    {
        robotSlug: 'training-arm-black',
        description: 'Join the queue to practice your skills. Open to Amplifiers and Innovators.',
        imageElement: (
            <div className={`${styles.robotImage} ${styles.robotImageBlackBg}`}><img src={robotArmSvg} alt="robotArm"/></div>
        )
    },
    {
        robotSlug: 'training-arm-gold',
        description: 'Join the queue to practice your skills. Open to Amplifiers and Innovators.',
        imageElement: (
            <div className={`${styles.robotImage} ${styles.robotImageGoldBg}`}><img src={robotArmSvg} alt="robotArm"/></div>
        )
    },
    // {
    //     robotSlug: 'training-arm-sliver',
    //     description: 'Join the queue to practice your skills. Open to Amplifiers and Innovators.',
    //     imageElement: (
    //         <div className={`${styles.robotImage} ${styles.robotImageSilverBg}`}><img src={robotArmSvg} alt="robotArm"/></div>
    //     )
    // },
    {
        robotSlug: 'arena-arm',
        description: 'Designed for high-volume sessions. Open to first-time users and Innovators.',
        imageElement: (
            <div className={styles.robotImage}><img src={robotArmSvg} alt="robotArm"/></div>
        )
    },
    {
        robotSlug: 'private-arm',
        description: 'Reserved for VIPs, partners, and special activations. Access requires a code and may vary by event.',
        imageElement: (
            <div className={styles.robotImageWrapper}>
                <div className={styles.robotImage}>
                    <img src={robotArmSvg} alt="robotArm"/>
                </div>
                <img src={reservedBanner} alt="reserved access banner" className={styles.reservedBannerRobotImage} />
            </div>
        )
    },
];

const TeleOpSelection = () => {
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState('select');
    const [sortBy, setSortBy] = useState('Date');
    const [showSortMenu, setShowSortMenu] = useState(false);
    const {
        showNotification,
        livePaused,
        robotDataDict, // Dictionary of robotId to { robotName, robotClass, robotSlug }
        robotSlugToRobotId // Dictionary of robotSlug to robotId
    } = useContext(SwapMainAppContext);

    // Placeholder session data
    const sessions = [
        {date: '23.06.25', robot: 'Played chess', duration: '30 minutes', reward: '30 Prisma Points', opponent: '--'},
        {
            date: '23.06.25',
            robot: 'Name of the robot',
            duration: '1 Hour : 30 minutes',
            reward: '30 Prisma Points',
            opponent: '--'
        },
        {
            date: '23.06.25',
            robot: 'Played chess',
            duration: '30 minutes',
            reward: '30 Prisma Points',
            opponent: '@john_doe'
        },
        {
            date: '23.06.25',
            robot: 'Name of the robot',
            duration: '30 minutes',
            reward: '30 Prisma Points',
            opponent: '--'
        },
        {
            date: '23.06.25',
            robot: 'Name of the robot',
            duration: '30 minutes',
            reward: '30 Prisma Points',
            opponent: '--'
        },
        {
            date: '23.06.25',
            robot: 'Played chess',
            duration: '30 minutes',
            reward: '30 Prisma Points',
            opponent: '@john_doe'
        },
        {
            date: '23.06.25',
            robot: 'Played chess',
            duration: '30 minutes',
            reward: '30 Prisma Points',
            opponent: '@john_doe'
        },
        {
            date: '23.06.25',
            robot: 'Name of the robot',
            duration: '30 minutes',
            reward: '30 Prisma Points',
            opponent: '--'
        },
        {
            date: '23.06.25',
            robot: 'Played chess',
            duration: '30 minutes',
            reward: '30 Prisma Points',
            opponent: '@john_doe'
        },
    ];

    const handleStartOperation = (robotId, robotData) => {
        if (robotId === 'arm1' || robotId === 'arm2' || robotId === 'arm3' || robotId === 'arm4' || robotId === 'arm5') {
            const paused = !!livePaused?.[robotId];
            const { robotName, robotSlug } = robotData;

            if (paused) {
                showNotification('warning', `We're on a break for ${robotName}. The live streaming will be restarted soon!`);
                return;
            }
            navigate(`/tele-op/${robotSlug}`);
        } else {
            showNotification('warning', 'Coming soon')
        }
    };

    const handleSort = (sortType) => {
        setSortBy(sortType);
        setShowSortMenu(false);
        // todo Add sorting logic here when connecting to actual data
    };

    // Split robots into rows of 3 for mobile horizontal scrolling
    const robotRows = ROBOT_RENDER_DATA.reduce((rows, robot, idx) => {
        const rowIndex = Math.floor(idx / 3);
        if (!rows[rowIndex]) rows[rowIndex] = [];
        rows[rowIndex].push(robot);
        return rows;
    }, []);

    const renderRobotCard = (robotRenderData) => {
        const { robotSlug } = robotRenderData;
        const robotId = robotSlugToRobotId[robotSlug] || '';
        const robotData = robotDataDict[robotId] ?? {} // robotData has keys robotName, robotClass, robotSlug
        return (
            <div onClick={() => handleStartOperation(robotId, robotData)} key={robotSlug} className={styles.robotCard}>           
                { robotRenderData.imageElement }
                <h3 className={styles.robotName}>{robotData.robotName}</h3>
                <p className={styles.robotDescription}>
                    {robotRenderData.description || ''}
                </p>
            </div>
        )
       
    };

    // else if (selectedRobot === 'arm2') {
    //     // return <TeleOpLocal robotId={selectedRobot}/>;
    // }

    return (
        <div className={styles.container} style={{width: activeTab === "select" ? "" : "100%"}}>
            <div className={styles.navBar}>
                <Link to="/live-control" className={styles.navLink}>
                    Live&nbsp;Control
                </Link>
                <span style={{marginInline: '10px'}}>&nbsp;|&nbsp;</span>
                <span className={styles.activeNavBar}>Robots&nbsp;Center</span>
                <img style={{marginInline: '10px'}} src={navRightArrow} alt="arrow"/>
                <span className={styles.navLink2}>
                    Robotic&nbsp;Arm&nbsp;Control
                </span>
            </div>
            <header className={styles.header}>
                <h1 className={styles.title}>Robot Control Center</h1>
                <nav className={styles.nav}>
                    <button
                        className={`${styles.navButton} ${activeTab === 'select' ? styles.active : ''}`}
                        onClick={() => setActiveTab('select')}
                    >
                        Robotic Arm
                    </button>
                    {/*<button*/}
                    {/*    className={`${styles.navButton} ${activeTab === 'previous' ? styles.active : ''}`}*/}
                    {/*     onClick={() => setActiveTab('previous')}*/}
                    {/*>*/}
                    {/*    Previous sessions*/}
                    {/*</button>*/}
                </nav>
            </header>

            {activeTab === 'select' ? (
                <>
                    <div className={`${styles.robotGrid} ${styles.desktopGrid}`}>
                        {ROBOT_RENDER_DATA.map((robotRenderData) => renderRobotCard(robotRenderData))}
                    </div>

                    {/* Mobile horizontal scroll rows */}
                    <div className={styles.mobileRows}>
                        {robotRows.map((row, rowIdx) => (
                            <div key={rowIdx} className={styles.robotRow}>
                                {row.map((robot) => renderRobotCard(robot))}
                            </div>
                        ))}
                    </div>
                </>
            ) : (
                <div className={styles.sessionsContainer}>
                    <div className={styles.sessionsHeader}>
                        <h2 className={styles.sessionsTitle}>Your sessions (9)</h2>
                        <div className={styles.sortContainer}>
                            <button
                                className={styles.sortButton}
                                onClick={() => setShowSortMenu(!showSortMenu)}
                            >
                                <span className={styles.filterIcon}>▼</span> Sort by
                            </button>
                            {showSortMenu && (
                                <div className={styles.sortMenu}>
                                    <div className={styles.sortMenuHeader}>Sort by</div>
                                    <label className={styles.sortOption}>
                                        <input
                                            type="radio"
                                            name="sort"
                                            checked={sortBy === 'Rewards'}
                                            onChange={() => handleSort('Rewards')}
                                        />
                                        <span>Rewards</span>
                                    </label>
                                    <label className={styles.sortOption}>
                                        <input
                                            type="radio"
                                            name="sort"
                                            checked={sortBy === 'Duration'}
                                            onChange={() => handleSort('Duration')}
                                        />
                                        <span>Duration</span>
                                    </label>
                                    <label className={styles.sortOption}>
                                        <input
                                            type="radio"
                                            name="sort"
                                            checked={sortBy === 'Date'}
                                            onChange={() => handleSort('Date')}
                                        />
                                        <span>Date</span>
                                    </label>
                                    <label className={styles.sortOption}>
                                        <input
                                            type="radio"
                                            name="sort"
                                            checked={sortBy === 'Opponents'}
                                            onChange={() => handleSort('Opponents')}
                                        />
                                        <span>Opponents</span>
                                    </label>
                                </div>
                            )}
                        </div>
                    </div>

                    <div className={styles.sessionsTable}>
                        <div className={styles.tableHeader}>
                            <div className={styles.headerCell}>Date</div>
                            <div className={styles.headerCell}>Robotic arm used</div>
                            <div className={styles.headerCell}>Duration</div>
                            <div className={styles.headerCell}>Rewards</div>
                            <div className={styles.headerCell}>Opponent</div>
                        </div>

                        {sessions.length === 0 ? (
                            <div className={styles.emptyState}>
                                <h2>Your sessions (0)</h2>
                                <div className={styles.emptyHeaders}>
                                    <span>Date</span>
                                    <span>Robotic arm used</span>
                                    <span>Duration</span>
                                    <span>Reward</span>
                                    <span>Opponent</span>
                                </div>
                            </div>
                        ) : (
                            sessions.map((session, index) => (
                                <div key={index} className={styles.tableRow}>
                                    <div className={styles.tableCell}>{session.date}</div>
                                    <div className={styles.tableCell}>{session.robot}</div>
                                    <div className={styles.tableCell}>{session.duration}</div>
                                    <div className={`${styles.tableCell} ${styles.rewardCell}`}>{session.reward}</div>
                                    <div className={styles.tableCell}>{session.opponent}</div>
                                </div>
                            ))
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default TeleOpSelection;
